// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"acd2104f","396":"f6ccd1a8","453":"3574c5ac","455":"9898376a","857":"ef532f40","977":"a43367bc"}[chunkId] + ".chunk.js";
};